import { legalTranslations } from './legal/fr';
import { privacyTranslations } from './privacy/fr';
import { termsTranslations } from './terms/fr';

export const frTranslations = {
  billing: {
    processingTitle: "Finalisation de ton abonnement…",
    processingMessage: "On confirme ton paiement, tu vas être redirigé.",
    confirmed: "Paiement confirmé !",
    paymentSuccessful: "Paiement réussi !",
    signInToAccess: "Connecte-toi pour accéder à ton espace Pro.",
  },
  cookies: {
    bannerTitle: "Nous respectons votre vie privée",
    bannerDescription:
      "Nous utilisons des cookies pour améliorer votre expérience et mesurer l'utilisation de Leadsme. Les cookies marketing ne sont activés qu'avec votre consentement.",
    acceptAll: "Tout accepter",
    rejectAll: "Tout refuser",
    preferences: "Préférences",
    privacyLink: "politique de confidentialité",
    learnMoreIn: "En savoir plus dans notre",
    manageCookies: "Gérer les cookies",
    preferencesTitle: "Préférences cookies",
    preferencesDescription:
      "Choisissez les cookies que vous acceptez. Vous pourrez modifier vos choix à tout moment.",
    categoryNecessary: "Strictement nécessaires",
    categoryNecessaryDescription:
      "Connexion, langue et fonctionnement du service.",
    categoryMarketing: "Marketing",
    categoryMarketingDescription:
      "Mesure de l'efficacité publicitaire. Déposés uniquement avec votre consentement.",
    alwaysActive: "Toujours actifs",
    savePreferences: "Enregistrer mes choix",
    learnMore: "En savoir plus :",
  },
  nav: {
    dashboard: "Tableau de bord",
    upgradeToPro: "Passe à Pro",
    tryPro: "Essayer Pro",
    calendar: "Calendrier",
    leads: "Leads",
    projects: "Projets",
    messages: "Messages",
    finances: "Finances",
    settings: "Paramètres",
    writeToTeam: "Écrire à l'équipe",
  },
  common: {
    create: "Créer",
    new: "Nouveau",
    update: "Mettre à jour",
    delete: "Supprimer",
    cancel: "Annuler",
    confirm: "Confirmer",
    undo: "Annuler",
    undoing: "Annulation...",
    save: "Enregistrer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    filters: "Filtres",
    export: "Exporter",
    import: "Importer",
    loading: "Chargement...",
    error: "Erreur",
    logout: "Déconnexion",
    today: "Aujourd'hui",
    validate: "Valider",
    abandon: "Abandonner",
    actions: "Actions",
    previous: "Précédent",
    next: "Suivant",
    retry: "Réessayer",
    allStatus: "Tous les statuts",
    allPeriods: "Toutes les périodes",
    period: "Période",
    thisMonth: "Ce mois",
    lastMonth: "Mois dernier",
    thisYear: "Cette année",
    total: "Total",
    clearFilters: "Effacer les filtres",
    tryAdjustingFilters: "Essaie de modifier ou de retirer tes filtres.",
    addFilter: "Ajouter un filtre",
    filterApply: "Appliquer",
    filterCancel: "Annuler",
    filter: "Filtrer",
    filterCondition: "Condition",
    filterValue: "Valeur",
    filterSelectColumn: "Choisir une colonne",
    filterOperatorIs: "est",
    filterOperatorIsNot: "n'est pas",
    filterOperatorContains: "contient",
    filterOperatorNotContains: "ne contient pas",
    filterOperatorIsEmpty: "est vide",
    filterOperatorIsNotEmpty: "n'est pas vide",
    filterOperatorGreaterThan: "est supérieur à",
    filterOperatorLessThan: "est inférieur à",
    filterOperatorBefore: "est avant",
    filterOperatorAfter: "est après",
    filterOperatorHasAnyValue: "a une valeur",
    moreActions: "Plus d'actions",
    selectStatus: "Sélectionner un statut",
    changeStatus: "Changer le statut",
    confirmBulkStatusChange: "Changer le statut de {{count}} élément(s) vers « {{status}} » ?",
    changeContactType: "Changer le type de contact",
    confirmBulkContactTypeChange:
      "Changer le type de contact de {{count}} lead(s) vers « {{type}} » ? La valeur de contact ne sera pas modifiée.",
    bulkSelectionStale:
      "Certains éléments sélectionnés ne sont plus disponibles. Rafraîchis la page si besoin.",
    reload: "Recharger",
    backToHome: "Retour à l'accueil",
    loadingTakingLongTitle: "Le chargement prend un peu plus de temps que prévu",
    loadingTakingLongMessage: "Tu peux recharger la page ou revenir à l'accueil.",
    collapse: "Réduire",
    expand: "Agrandir",
    close: "Fermer",
    on: "Activé",
    off: "Désactivé",
    notAuthenticated: "Tu dois être connecté pour effectuer cette action",
    notes: "Notes",
    saveFailedRollback: "Enregistrement impossible (problème réseau ou serveur). Les données ont été rechargées.",
    exportSuccess: "{{count}} élément(s) exporté(s) avec succès",
    selectedOfTotal: "{{selected}} sur {{total}} sélectionné(s)",
    selectedCountOnly: "{{count}} sélectionné(s)",
  },
  followups: {
    count: "Nombre de relances",
    maxDisplayed: "Maximum {{max}} affiché(s)",
    title: "Relances",
    all: "Tout",
    overdue: "En retard",
    today: "Aujourd'hui",
    relaunch: "Relancer",
    statusTodo: "À faire",
    statusLate: "En retard",
    statusVeryLate: "Très en retard",
    seeOthers: "Voir les {{count}} autres",
    emptyTab: "Rien dans cet onglet pour le moment.",
    showMore: "Voir plus",
    showLess: "Voir moins",
    moreCount: "de plus",
    noFollowUps: "Aucun suivi en cours",
    noFollowUpsDescription: "Bravo ! Tu es à jour. Tous tes suivis sont terminés.",
  },
  dashboard: {
    title: "Tableau de bord",
    greetingHello: "Bonjour 👋",
    greetingHelloName: "Bonjour, {{name}} 👋",
    subtitle: "Ton activité en un coup d'œil.",
    thisMonth: "ce mois",
    commercialPipeline: "Pipeline Commercial",
    conversionRate: "Taux de conversion",
    conversionRateTooltip: "Pourcentage de leads en production ou terminés. Calcul : (En production + Terminés / Total leads) × 100",
    pipelineStageTooltip: "Voir tous les leads « {{status}} »",
    pipelineStageTooltipClear: "Retirer le filtre « {{status}} »",
    noFollowUpScheduled: "Aucun suivi prévu aujourd'hui",
    recentProjects: "Projets Récents",
    noRecentProjects: "Aucun projet récent",
    urgentActions: "Actions Urgentes",
    followUpScheduled: "Suivi prévu",
    paymentsDue: "Paiements à Échéance",
    dueDate: "Échéance",
    pending: "En attente",
    topLeads: "Top Leads",
    topProjects: "Top Projets",
    noDataYet: "Pas encore de données",
    unknownLead: "Lead inconnu",
    congratulations: "Félicitations !",
    bestLeadMessage: "<strong>{{name}}</strong> représente {{percentage}}% de tes revenus {{period}}.",
    bestProjectMessage: "<strong>{{name}}</strong> représente {{percentage}}% de tes revenus {{period}}.",
    thisYear: "cette année",
    total: "total",
    rightsWatchTitle: "Droits d'image à surveiller",
    rightsWatchSubtitle: "Les échéances les plus anciennes non encore validées.",
    rightsUntil: "Jusqu'au {{date}}",
    rightsExpiredOn: "Expiré le {{date}}",
    rightsExpired: "Expiré",
    rightsInProgress: "En cours",
    rightsMarkChecked: "Respecté",
    rightsMarkedChecked: "Droits d'image marqués comme respectés : {{name}}",
    rightsMarkCheckedError: "Impossible de marquer les droits comme respectés",
    noRightsToWatch: "Aucun droit d'image à surveiller",
    firstLeadHint: "Ajoute ta première marque pour démarrer.",
    firstLeadCta: "Créer mon premier lead",
    firstProjectHint: "Passe une collab en projet pour la suivre.",
    firstProjectCta: "Créer mon premier projet",
  },
  demoTour: {
    badge: "Démo",
    back: "Retour",
    next: "Suivant",
    createWorkspace: "Créer mon espace",
    createdToast: "Espace prêt",
    readonlyToast: "C’est une démo en lecture seule. Tu pourras tout modifier dans ton espace.",
    actionError: "Impossible de quitter le mode démo",
    welcomeTitle: "Bienvenue sur Leadsme",
    welcomeSubtitle: "On te montre en 1 minute ?",
    welcomeBody: "Ton espace est vide. On a préparé une courte démo avec des données exemples.",
    welcomeYes: "Oui, lancer la démo",
    welcomeNo: "Non, créer mon espace vide",
    deferredTitle: "La démo est sur ordinateur",
    deferredBody: "Tu peux déjà utiliser ton espace ici. La visite guidée t’attendra sur PC.",
    deferredDismiss: "Compris",
    stepDashboard: "Tableau de bord",
    stepDashboardBody: "Tout ce qui mérite ton attention, réuni au même endroit. Commence ta journée en sachant exactement quoi faire.",
    stepLeads: "Leads",
    stepLeadsBody: "Suis chaque marque, du premier contact jusqu’à la collaboration. Toutes les informations utiles restent accessibles en un clic.",
    stepProjects: "Projets",
    stepProjectsBody: "Centralise le brief, les livrables, les échéances et les droits de chaque collaboration. Tu sais toujours où en est ton projet.",
    stepMessages: "Messages",
    stepMessagesBody: "Prépare tes prises de contact et tes relances plus rapidement. Choisis un modèle, personnalise-le et envoie-le à la marque.",
    stepFinances: "Finances",
    stepFinancesBody: "Garde un œil sur tes paiements reçus, à venir ou en retard. Une vision claire de ta trésorerie, sans tableur.",
    stepCalendar: "Calendrier",
    stepCalendarBody: "Tournages, rendez-vous et relances dans un seul planning. Visualise ta semaine sans rien oublier.",
  },
  leads: {
    title: "Leads",
    singular: "Lead",
    createNew: "Nouveau lead",
    createNamed: "Créer « {{name}} »",
    searchLead: "Rechercher un lead...",
    created: "{{name}} créé",
    createError: "Impossible de créer le lead",
    name: "Nom",
    contactType: "Type de contact",
    contactValue: "Contact",
    sector: "Secteur",
    status: "Statut",
    source: "Source",
    notes: "Notes",
    createdAt: "Créé le",
    lastAction: "Dernière Action",
    nextAction: "Prochaine Action",
    nextFollowUp: "Prochain suivi",
    noLeadsToExport: "Aucun lead à exporter. Vérifie tes filtres.",
    deleted: "{{name}} supprimé",
    confirmDeleteWithProjectsTitle: "Supprimer le lead ?",
    confirmDeleteWithProjects:
      "Ce lead a {{count}} projet(s) associé(s). Les projets, leurs paiements et leurs fichiers seront définitivement supprimés.",
    confirmBulkDelete: "Supprimer {{count}} leads ?",
    confirmBulkDeleteWithProjects:
      "Supprimer {{count}} leads ? Cela supprimera aussi {{projectCount}} projet(s) associé(s), leurs paiements et leurs fichiers.",
    bulkContactTypeUpdated: "Type de contact mis à jour pour {{count}} lead(s)",
    notesPlaceholder: "Informations complémentaires, historique des échanges...",
    noLeads: "Aucune marque pour l'instant",
    noLeadsDescription: "Ajoute ta première marque pour démarrer ta prospection.",
    noLeadsFound: "Aucun lead trouvé",
    createFirst: "Ajouter un lead",
    allSectors: "Tous les secteurs",
    allContactTypes: "Tous les types de contact",
    allDirections: "Toutes les directions",
    allStatuses: "Tous les statuts",
    scheduledOn: "Prévu le",
    manageLeads: "Gère tes leads et suis ton pipeline commercial",
    pagination: {
    },
    nameRequired: "Le nom est requis",
    statusRequired: "Le statut est requis",
    namePlaceholder: "ex: Nom de l'entreprise...",
    chooseSector: "Choisir un secteur",
    direction: "Direction",
    chooseDirection: "Choisir la direction",
    newContactType: "Nouveau type de contact...",
    newSector: "Nouveau secteur...",
    addCategories: "Ajouter des catégories",
    delete: "Supprimer",
    confirmDeleteCategory: "Cette catégorie est utilisée par {count} lead(s). Tu veux vraiment la supprimer ? Les leads seront automatiquement passés à 'Other'.",
    confirmDeleteSector: "Ce secteur est utilisé par {count} lead(s). Tu veux vraiment le supprimer ? Le secteur sera retiré de ces leads.",
    statusInProduction: "En production",
    statusCompleted: "Terminé",
    autoStatusWarning: "Les statuts {{status1}} et {{status2}} se mettent aussi à jour automatiquement via tes projets. Astuce : crée un projet depuis le menu ⋯ de la ligne.",
    autoStatusCreateProject: "Montrer",
    contactValuePlaceholder: "Ex: @username, +33123456789, contact@example.com",
    noContact: "Pas de contact",
    contactTypes: {
    },
    sendMessage: "Envoyer un message",
    rescheduleFollowUp: "Replanifier le suivi",
    moveTo: "Passer à",
    markAsAbandoned: "Marquer comme abandonné",
    markAsRejected: "Marquer comme refusé",
    rescheduleTitle: "Replanifier le suivi",
    newFollowUpDate: "Nouvelle date de suivi",
    quickSuggestions: "Suggestions rapides",
    tomorrow: "Demain",
    nextWeek: "Semaine prochaine",
    nextMonth: "Mois prochain",
    nextYear: "Année prochaine",
  },
  projects: {
    title: "Projets",
    singular: "Projet",
    createNew: "Nouveau Projet",
    createNamed: "Créer « {{name}} »",
    created: "{{name}} créé",
    createError: "Impossible de créer le projet",
    moveTo: "Passer à",
    name: "Nom du projet",
    nameRequired: "Le nom est requis",
    leadRequired: "Le lead est requis",
    leadStillSaving: "Le lead est encore en cours d'enregistrement. Réessaie dans une seconde.",
    description: "Description",
    deliverables: "Livrables attendus",
    deliverableType: "Type de livrable",
    unknownLead: "Lead inconnu",
    typeRequired: "Le type est requis",
    platforms: "Plateformes",
    status: "Statut",
    type: "Type",
    lead: "Lead",
    namePlaceholder: "Nom du projet...",
    descriptionPlaceholder: "Décris le projet et les attentes...",
    deliverablesPlaceholder: "Ex: 3 reels, 2 stories, 1 post",
    platformsPlaceholder: "Ex: Instagram, TikTok",
    manageProjectsDescription: "Suis tes productions et gère tes livrables",
    newProject: "Nouveau Projet",
    allTypes: "Tous les types",
    noProjects: "Aucune collab pour l'instant",
    noProjectsDescription: "Crée ta première collaboration pour suivre tes livrables.",
    createFirst: "Créer un projet",
    noProjectsToExport: "Aucun projet à exporter. Vérifie tes filtres.",
    deleted: "{{name}} supprimé",
    confirmDeleteWithPaymentsTitle: "Supprimer le projet ?",
    confirmDeleteWithPayments:
      "Ce projet a {{count}} suivi(s) de paiement. Les paiements et les fichiers associés seront définitivement supprimés.",
    confirmBulkDelete: "Supprimer {{count}} projets ?",
    confirmBulkDeleteWithPayments:
      "Supprimer {{count}} projets ? Cela supprimera aussi {{paymentCount}} suivi(s) de paiement et les fichiers associés.",
    fileUploadedSuccess: "{{name}} uploadé(s) avec succès",
    filesUploadedPartial: "{{success}} uploadé(s), {{error}} en échec",
    documentDeleted: "{{name}} supprimé",
    deleteDocumentConfirm: "Supprimer « {{name}} » ? Cette action est irréversible.",
    searchProject: "Rechercher un projet...",
    searchLead: "Rechercher un lead...",
    generalInfo: "Informations générales",
    financialInfo: "Informations financières",
    assignmentRights: "Droits de cession",
    rightsPlannedTooltip: "Droits de cession prévus",
    rightsEndTooltip: "Fin des droits de cession",
    hasAssignmentRights: "Il y a cession de droits",
    noAssignmentRights: "Aucune cession de droits",
    deadline: "Date limite",
    amount: "Montant",
    amountRequired: "Le montant est requis",
    amountPositive: "Le montant doit être positif",
    amountPlaceholder: "1500",
    currency: "Devise",
    territory: "Territoire",
    territoryPlaceholder: "France, Europe, Monde",
    durationLabel: "Durée",
    durationPlaceholder: "12",
    durationMin: "Au moins 1",
    durationUnitDays: "Jours",
    durationUnitWeeks: "Semaines",
    durationUnitMonths: "Mois",
    durationMonthSingular: "mois",
    durationMonthsPlural: "mois",
    durationWeekSingular: "semaine",
    durationWeeksPlural: "semaines",
    durationDaySingular: "jour",
    durationDaysPlural: "jours",
    exclusiveRights: "Droits exclusifs",
    activateImageRights: "Activer les droits d'image",
    editImageRights: "Modifier les droits d'image",
    activateImageRightsDescription: "Confirme le début de diffusion et ajuste les droits de cession si besoin. La fin des droits est calculée automatiquement.",
    diffusionStarted: "Activer les droits d'image",
    diffusionStartedDescription: "Confirme le début de diffusion et ajuste les droits de cession si besoin. La fin des droits est calculée automatiquement.",
    diffusionStartDate: "Date de début de diffusion",
    confirmDiffusionStarted: "Confirmer",
    rightsUntil: "Jusqu'au {{date}}",
    rightsUntilLabel: "Jusqu'au",
    rightsUntilPreview: "{{duration}} → jusqu'au {{date}}",
    rightsExpiredOn: "Expiré le {{date}}",
    rightsExpired: "Expiré",
    rightsInProgress: "En cours",
    rightsRespected: "Respecté",
    rightsDurationPending: "Durée · {{duration}}",
    rightsDurationPendingHint: "Droits pas encore activés. La date de fin sera fixée à l’activation.",
    rightsEndColumn: "Fin des droits",
    imageRightsBadge: "droits d'image",
    diffusionStartedSuccess: "Droits d'image activés jusqu'au {{date}}",
    createProject: "Créer un projet",
    viewProject: "Voir le projet",
    manageProjects: "Gérer les projets",
    noProjectsYet: "Aucun projet pour ce lead",
    project: "projet",
    statusBriefReceived: "Brief Reçu",
    statusInProduction: "En Production",
    statusFirstVersion: "V1 Envoyée",
    statusCorrections: "Corrections Demandées",
    statusDelivered: "Livré",
    statusArchived: "Archivé",
    statusBriefShort: "Brief",
    statusProductionShort: "Prod",
    statusV1Short: "V1",
    statusCorrectionsShort: "Corrections",
    statusDeliveredShort: "Livré",
    statusArchivedShort: "Archivés",
    typeShortVideo: "Vidéo courte",
    typePhoto: "Photo",
    typeVoiceOver: "Voice Over",
    typeStory: "Story",
    typePost: "Post / Carrousel",
    typeLongVideo: "Vidéo longue",
    typeOther: "Autre",
    noBriefMessage: "Aucun brief disponible pour ce projet",
    documentUploadError: "Erreur lors de l'upload du document",
    documentOpenError: "Erreur lors de l'ouverture du document",
    quotaExceeded: "Quota dépassé",
    documents: "Documents",
    addDocument: "Ajouter un document",
    addDocumentTooltip: "Ajouter un document",
    document: "Document",
    viewDocument: "Voir",
    openingDocument: "Ouverture…",
    sendDocumentToDrive: "Envoyer vers Drive",
    sendDocumentToDriveNamed: "Envoyer vers « {{name}} »",
    chooseDriveFolder: "Choisir un dossier…",
    chooseDriveFile: "Choisir un fichier Drive…",
    linkDocumentFromDrive: "Lier depuis Drive",
    openingDrivePicker: "Ouverture de Drive…",
    openDocumentInDrive: "Ouvrir dans Drive",
    resendDocumentToDrive: "Renvoyer vers Drive",
    documentSentToDrive: "{{name}} envoyé vers Drive",
    documentLinkedFromDrive: "{{name}} lié depuis Drive",
    documentAlreadyLinkedFromDrive: "{{name}} est déjà lié",
    documentDriveNotConnected: "Connecte Google Drive dans Paramètres → Intégrations",
    documentDriveExportError: "Impossible d’envoyer vers Drive",
    documentDriveLinkError: "Impossible de lier le fichier Drive",
    documentDriveLinkInaccessible:
      "Impossible d’accéder à ce fichier. Choisis un PDF ou une image dans Mon Drive.",
    documentDriveLinkSchemaError:
      "Impossible de lier ce fichier pour le moment. Réessaie dans un instant.",
    documentDriveMissing: "Ce fichier n’est plus disponible dans Drive. Tu peux l’envoyer à nouveau.",
    documentDriveLinkMissing: "Ce fichier n’est plus disponible dans Drive. Le lien a été retiré.",
    documentDriveOpenError: "Impossible d’ouvrir le fichier dans Drive",
    documentDrivePickerError: "Impossible d’ouvrir le sélecteur Drive",
    documentDrivePickerNotConfigured: "Le sélecteur Drive n’est pas encore configuré.",
    deleteDocument: "Supprimer",
    deleteDocumentTitle: "Supprimer le document",
    unlinkDocument: "Retirer le lien",
    unlinkDocumentTitle: "Retirer le lien Drive",
    unlinkDocumentConfirm: "Retirer « {{name}} » de ce projet ? Le fichier reste dans Drive.",
    documentUnlinked: "{{name}} retiré",
    documentDeleteError: "Erreur lors de la suppression du document",
    invalidFileType: "Seuls les fichiers PDF et images (JPG, PNG, WEBP, GIF) sont autorisés pour les documents de projet.",
    dropHere: "Déposer ici",
    dropFilesHere: "Dépose tes fichiers ici",
    noArchivedProjects: "Aucun projet archivé",
    noArchivedProjectsDescription: "Les projets archivés apparaîtront ici.",
    backToKanban: "Retour à la vue Kanban",
    selectAll: "Tout sélectionner",
    paid: "Payé",
    overdue: "En retard",
    archived: "archivé",
    viewPayment: "Voir le paiement",
    createPayment: "Créer un paiement",
    addPayment: "Ajouter le paiement",
    trackPayment: "Suivre le paiement",
    saveProjectFirst: "Enregistre d'abord le projet pour ajouter des documents ou des paiements.",
    noProjectsFound: "Aucun projet trouvé",
  },
  payments: {
    singular: "Paiement",
    noPayments: "Aucun paiement pour l'instant",
    noPaymentsDescription: "Note ton premier paiement pour suivre tes encaissements.",
    createFirst: "Ajouter un paiement",
    noPaymentsFound: "Aucun paiement trouvé",
    project: "Projet",
    issueDate: "Date d'émission",
    dueDate: "Date d'échéance",
    dateLabel: "Échéance / Payé",
    dateLabelShort: "Éch./Payé",
    dueOn: "Échéance",
    dueShort: "Éch.",
    paidOn: "Payé le",
    paidShort: "Payé",
    paymentDate: "Date de paiement",
    status: "Statut",
    amount: "Montant",
    markAsPaid: "Marquer comme payé",
    statusLabels: {
      sent: "Envoyé",
      paid: "Payé",
      overdue: "En retard",
      pending: "En attente",
    },
    createPayment: "Créer un paiement",
    newPayment: "Nouveau paiement",
    editPayment: "Modifier le paiement",
    projectRequired: "Sélectionne un projet",
    viewProject: "Voir le projet",
    paymentDetails: "Détails du paiement",
    issueDateRequired: "La date d'émission est requise",
    dueDateRequired: "La date d'échéance est requise",
    amountRequired: "Le montant est requis",
    amountMin: "Minimum : 0,01",
    amountBaseCurrencyRequired: "Le montant en devise de base est requis",
    amountReceivedBaseCurrency: "Montant perçu ({{currency}})",
    amountReceivedBaseCurrencyHelp: "Montant réellement perçu (peut différer du montant facturé).",
    statusLabel: "Statut",
    searchByProject: "Rechercher par projet...",
    noPaymentsToExport: "Aucun paiement à exporter",
    invoiceNumber: "N° facture",
    invoice: "Facture",
    invoiceShort: "Fact.",
    addInvoice: "+ Ajouter",
    addInvoiceShort: "+",
    addInvoiceTooltip: "Créer une facture pour ce paiement",
    viewInvoicePdfTooltip: "Télécharger le PDF",
    selectedNoLongerAvailable: "Certains éléments sélectionnés ne sont plus disponibles. Rafraîchis la page si besoin.",
    deleted: "Paiement supprimé",
    confirmBulkDelete: "Supprimer {{count}} paiements ?",
  },
  invoices: {
    singular: "Facture",
    createTitle: "Nouvelle facture",
    seller: "Vendeur",
    invoiceInfo: "Informations",
    billedTo: "Client",
    buyerNameRequired: "Le nom du client est requis",
    lineItems: "Articles",
    item: "Produit ou service",
    itemColumn: "Désignation",
    itemPlaceholder: "Ex. 3 vidéos UGC produit",
    itemDetails: "Description",
    itemDetailsPlaceholder: "Précisions, livrables…",
    qty: "Quantité",
    unitPrice: "Prix unitaire",
    vatRate: "TVA",
    vatNotApplicable: "Non applicable",
    lineTotal: "Total",
    total: "Total",
    addLine: "Ajouter une ligne",
    duplicateLine: "Dupliquer",
    moveLineUp: "Monter",
    moveLineDown: "Descendre",
    linesRequired: "Ajoute au moins une ligne avec une désignation",
    emitTitle: "Nouvelle facture",
    emitIntro: "",
    emit: "Créer la facture",
    preview: "Aperçu",
    sectionsCompleted: "{{done}} sections sur {{total}} complétées",
    profileUpdateBadge: "Met à jour le profil",
    paymentMissing: "Paiement introuvable",
    loadError: "Impossible de charger la facture",
    alreadyExists: "Une facture existe déjà pour ce paiement",
    backToFinances: "Retour aux finances",
    invoiceNumber: "N° facture",
    invoiceNumberRequired: "Le numéro de facture est requis",
    invoiceName: "Nom de la facture",
    invoiceNamePlaceholder: "Ex. Campagne UGC mars",
    issuedAt: "Date",
    issuedAtRequired: "La date est requise",
    invoiceDetails: "Facture",
    paymentSummary: "Paiement lié",
    project: "Projet",
    amount: "Montant",
    notes: "Notes (optionnel)",
    notesPlaceholder: "Mentions légales, remarques…",
    paymentTerms: "Conditions de paiement",
    paymentDueDelay: "Délai",
    paymentDueReceipt: "À réception",
    paymentDueDays: "{{days}} jours",
    paymentDuePhraseReceipt: "Paiement à réception",
    paymentDuePhraseDays: "Paiement à {{days}} jours",
    paymentTermsNotes: "Précisions (optionnel)",
    paymentTermsNotesPlaceholder: "Pénalités de retard, escompte…",
    paymentSection: "Paiement",
    paymentMethod: "Mode de paiement",
    paymentMethodTransfer: "Virement",
    paymentMethodPaypal: "PayPal",
    paymentMethodCheck: "Chèque",
    paymentMethodOther: "Autre",
    accountHolder: "Titulaire",
    accountHolderPlaceholder: "Nom du titulaire du compte",
    ibanLabel: "IBAN",
    ibanPlaceholder: "FR76 …",
    bicLabel: "BIC",
    bicPlaceholder: "ABCDEFGH",
    sellerFromProfileHint: "",
    create: "Créer la facture",
    created: "Facture créée",
    createError: "Impossible de créer la facture",
    numberTaken: "Ce numéro de facture est déjà utilisé",
    downloadPdf: "Télécharger le PDF",
    pdfTitle: "Facture",
    pdfFrom: "Vendeur",
    pdfTo: "Client",
    pdfDueDate: "Échéance",
    pdfPaymentDate: "Payé le",
    pdfStatus: "Statut",
    pdfAmount: "Montant",
    pdfNotes: "Notes",
    pdfSiret: "SIRET",
    pdfVatNumber: "TVA",
  },
  messages: {
    singular: "Modèle",
    title: "Messages",
    newTemplate: "Nouveau modèle",
    manageTemplates: "Crée et gère tes modèles de messages pour tes leads",
    emailTemplates: "Modèles de messages",
    templatesShort: "Modèles",
    composeMessage: "Composer un message",
    selectBrand: "Sélectionner un lead",
    message: "Message",
    personalizedPreview: "Aperçu Personnalisé",
    to: "À",
    noTemplatesToExport: "Aucun modèle à exporter",
    noTemplates: "Aucun message type pour l'instant",
    noTemplatesDescription: "Prépare un modèle pour gagner du temps sur tes prochains emails.",
    noTemplatesForFilter: "Aucun modèle de ce type",
    noTemplatesForFilterDescription: "Change de filtre ou crée un nouveau modèle.",
    clearTypeFilter: "Voir tous les modèles",
    filterByType: "Filtrer par type",
    filterAll: "Tous",
    createFirst: "Créer un modèle",
    subject: "Objet",
    templateNamePlaceholder: "Ex: Premier contact - Générique",
    contentPlaceholder: "Rédige ton message ici...",
    templateNameLabel: "Nom du modèle",
    templateNameRequired: "Le nom du modèle est requis.",
    typeLabel: "Type de modèle",
    emailSubjectLabel: "Objet (optionnel)",
    emailSubjectPlaceholder: "Ex: Collaboration UGC avec {lead_company}",
    contentLabel: "Contenu du message",
    openEmail: "Ouvrir dans Gmail",
    copyToClipboard: "Copier",
    messageCopied: "Message copié dans le presse-papier",
    messageCopiedAndOpened: "Message copié, canal ouvert",
    openContactOpened: "Canal ouvert",
    openContactUnavailable: "Impossible d'ouvrir ce contact",
    openWhatsApp: "Ouvrir WhatsApp",
    openInstagram: "Voir le profil Instagram",
    openTikTok: "Voir le profil TikTok",
    openFacebook: "Voir le profil Facebook",
    openTwitter: "Voir le profil X",
    openLinkedIn: "Voir le profil LinkedIn",
    openYouTube: "Voir la chaîne YouTube",
    openWebsite: "Ouvrir le site",
    openSms: "Ouvrir SMS",
    copyTemplate: "Copier",
    useTemplate: "Utiliser le modèle dans le message",
    deselectTemplate: "Désélectionner le modèle",
    rewriteWithAI: "Réécrire",
    rewriteSuggest: "Suggérer",
    rewriteAIPromptLabel: "Améliorer avec l'IA",
    rewriteWithAIPrompt: "Autre instruction…",
    rewriteWithAILoading: "Suggestion…",
    rewriteWithAIUpgradeTitle: "Passe à Pro pour utiliser la réécriture IA",
    rewriteQuick: {
      professional: "Plus professionnel",
      shorter: "Plus court",
      warmer: "Plus chaleureux",
      fixForm: "Corriger la forme",
      moreNatural: "Plus naturel",
      translateEn: "Traduire en anglais",
    },
    rewriteQuickInstruction: {
      professional: "Rends le message plus professionnel, sans le rendre commercial ni spammy.",
      shorter: "Raccourcis le message en gardant l'essentiel et le même ton.",
      warmer: "Rends le message plus chaleureux et humain, sans le rendre collant.",
      fixForm:
        "Corrige l'orthographe, la grammaire, la ponctuation et la fluidité. Ne change pas le ton ni le sens.",
      moreNatural:
        "Rends le message plus naturel et moins robotique. Garde le sens et le ton.",
      translateEn: "Traduis le message en anglais en gardant le même ton et le même sens.",
    },
    rewriteQuickTooltip: {
      fixForm: "Corrige la forme et les erreurs d'orthographe, sans changer le sens",
      professional: "Ton plus professionnel, sans sonner commercial",
      warmer: "Ton plus chaleureux et humain",
      shorter: "Raccourcit en gardant l'essentiel",
      moreNatural: "Moins robotique, plus naturel à lire",
      translateEn: "Traduit en anglais en gardant le même ton",
    },
    rewriteSuccess: "Message réécrit",
    rewriteBackTooltip: "Annuler la dernière suggestion acceptée",
    rewriteSuggestionTitle: "Suggestion IA",
    rewriteBasedOn: "basée sur « {{action}} »",
    rewriteInlineHint: "Suggestions · {{action}}",
    rewriteAccept: "Accepter",
    rewriteReject: "Refuser",
    rewriteAcceptAll: "Tout accepter",
    rewriteRejectAll: "Tout refuser",
    rewriteBulkHint: "Ou gérer toutes les suggestions d’un coup",
    rewriteNoChanges: "Aucun changement proposé",
    rewriteFailed: "La réécriture a échoué. Réessaie.",
    rewriteError_CONTENT_TOO_LONG: "Message trop long pour la réécriture.",
    rewriteError_INSTRUCTION_TOO_LONG: "Instruction trop longue.",
    rewriteError_RATE_LIMIT: "Trop de réécritures. Réessaie dans une minute.",
    rewriteError_TIMEOUT: "La réécriture a pris trop de temps. Réessaie.",
    proFeatureModalTitle: "Fonctionnalité Pro",
    copy: "Copie",
    copyError: "Erreur lors de la copie du modèle",
    copied: "{{name}} copié",
    deleted: "{{name}} supprimé",
    searchBrand: "Rechercher une marque...",
    recipientPlaceholder: "Choisis un lead ou saisis le contact",
    emailSubject: "Sujet de l'email...",
    personalizedMessage: "Ton message personnalisé...",
    variablesHelpTitle: "Variables",
    variablesInsertHint: "Clique sur une variable pour l'insérer dans le message",
    varGroupLead: "Lead",
    varGroupMe: "Toi",
    varGroupProject: "Projet",
    varGroupOther: "Date",
    varSelectProjectHint: "Sélectionne un projet pour utiliser ces variables",
    selectProjectOptional: "Projet (optionnel)",
    noProjectSelected: "Aucun projet",
    noProjectsForLead: "Aucun projet pour ce lead",
    var: {
      leadName: "Nom du lead",
      leadFirstName: "Prénom",
      leadContact: "Contact",
      leadSector: "Secteur",
      myName: "Ton nom",
      myCompany: "Ton entreprise",
      projectName: "Nom du projet",
      projectType: "Type",
      projectAmount: "Montant",
      projectDeadline: "Deadline",
      projectDeliverables: "Livrables",
      rightsPlatforms: "Plateformes",
      rightsDuration: "Durée des droits",
      rightsTerritory: "Territoire",
      rightsExclusivity: "Exclusivité",
      rightsStart: "Début des droits",
      rightsEnd: "Fin des droits",
      today: "Aujourd'hui",
      tomorrow: "Demain",
      in1Week: "Dans 1 semaine",
      in1Month: "Dans 1 mois",
    },
    varTooltip: {
      leadName: "Ajoute le nom du lead",
      leadFirstName: "Ajoute le prénom du lead",
      leadContact: "Ajoute le contact du lead",
      leadSector: "Ajoute le secteur du lead",
      myName: "Ajoute ton nom",
      myCompany: "Ajoute le nom de ton entreprise",
      projectName: "Ajoute le nom du projet",
      projectType: "Ajoute le type de projet",
      projectAmount: "Ajoute le montant du projet",
      projectDeadline: "Ajoute la deadline du projet",
      projectDeliverables: "Ajoute les livrables du projet",
      rightsPlatforms: "Ajoute les plateformes des droits",
      rightsDuration: "Ajoute la durée des droits",
      rightsTerritory: "Ajoute le territoire des droits",
      rightsExclusivity: "Ajoute l'exclusivité des droits",
      rightsStart: "Ajoute la date de début des droits",
      rightsEnd: "Ajoute la date de fin des droits",
      today: "Ajoute la date du jour",
      tomorrow: "Ajoute la date de demain",
      in1Week: "Ajoute la date dans une semaine",
      in1Month: "Ajoute la date dans un mois",
    },
    gmailSendTitle: "Envoi Gmail",
    gmailSendModalTitle: "Envoyer avec Gmail",
    gmailSendModalSubtitle: "Vérifie le destinataire avant d'envoyer",
    gmailSendModalLead: "Envoyer à {{name}}",
    gmailSendFrom: "Depuis {{email}}",
    gmailSendNowHint: "L'email part immédiatement via ton compte Gmail",
    gmailSendConfirm: "Envoyer",
    gmailPreview: "Aperçu",
    gmailAttachments: "Pièces jointes",
    gmailIncludeSignature: "Inclure la signature",
    gmailConnectHint: "Connecter Gmail pour envoyer directement depuis Leadsme",
    gmailRecipient: "Destinataire",
    gmailOpenInGmail: "Ouvrir dans Gmail",
    gmailClearHistory: "Effacer",
    gmailHistoryCleared: "Historique d'envoi effacé",
    gmailClearHistoryError: "Impossible d'effacer l'historique",
    gmailNoSentYet: "Aucun email envoyé depuis Leadsme pour ce lead.",
    gmailSend: "Envoyer",
    gmailSent: "Email envoyé",
    gmailSendError: "Échec de l'envoi",
    gmailError_RATE_LIMIT: "Tu as fait trop d'actions Gmail d'un coup. Réessaie dans une minute.",
    gmailError_TOO_MANY_ATTACHMENTS: "Trop de pièces jointes (max 5).",
    gmailError_ATTACHMENTS_TOO_LARGE: "Pièces jointes trop lourdes (max 15 Mo au total).",
    gmailError_ATTACHMENT_DRIVE_LINK: "Les fichiers Drive liés ne peuvent pas être joints. Uploade une copie sur le projet.",
    gmailError_ATTACHMENT_INVALID: "Impossible de joindre un de ces fichiers. Réessaie.",
    attach: "Joindre",
    attachFile: "Joindre un fichier",
    attachSelectedCount: "{{count}} fichier(s) joint(s)",
    attachProjectFiles: "Joindre un document du projet",
    attachFromProject: "Fichiers du projet",
    noProjectFilesToAttach: "Aucun document uploadé sur ce projet",
    attachLimitHint: "{{max}} fichiers max · 15 Mo au total",
    detachFile: "Retirer {{name}}",
    gmailInvalidEmail: "Indique une adresse email valide",
    gmailSubjectRequired: "L'objet est requis pour envoyer",
    gmailNoSubject: "Sans objet",
    type: {
      leadGeneration: "Acquisition de leads",
      followUp: "Suivi",
      negotiation: "Négociation",
      delivery: "Livraison",
    },
    typeShort: {
      leadGeneration: "Acquisition",
      followUp: "Suivi",
      negotiation: "Négociation",
      delivery: "Livraison",
    },
  },
  templates: {
    singular: "Modèle",
    name: "Nom",
    contentType: "Type de contenu",
    subject: "Sujet",
    content: "Contenu",
    createdAt: "Créé le",
  },
  finances: {
    title: "Finances",
    revenue: "Revenus",
    estimatedTaxes: "Taxes estimées",
    editTaxRate: "Modifier le taux",
    currentMonth: "Mois actuel",
    currentWeek: "Semaine actuelle",
    currentYear: "Année actuelle",
    manageFinances: "Suis tes revenus, paiements et fiscalité",
    exportError: "Erreur lors de l'export des finances",
    netRevenue: "Revenus nets",
    grossRevenue: "Revenus bruts",
    deletedProject: "Projet supprimé",
    pending: "En Attente",
    overdue: "En Retard",
    revenueChart: "Graphique des Revenus",
    upcomingPayments: "Paiements à Venir",
    noUpcomingPayments: "Aucun paiement en attente pour le moment",
    allCaughtUp: "Tout est à jour !",
    monthlyFinancialSummary: "Résumé Financier",
    summaryShort: "Résumé",
    taxDisclaimer: "Indicatif, à confirmer avec ton comptable.",
  },
  organization: {
    title: "Organisation",
    export: {
    },
    reminders: "Rappels",
    scheduleDescription: "Gère ton planning et tes échéances",
    schedule: "Planning",
    recentActivity: "Activité Récente",
    goalsDescription: "Définis et suis tes objectifs",
    tasksDescription: "Organise tes tâches et priorités",
    manageOrganization: "Gère ton organisation et tes données",
    totalLeads: "Total Leads",
    totalProjects: "Total Projets",
    recentActivities: "Activités Récentes",
    viewCalendar: "Voir le calendrier",
    goals: "Objectifs",
    setGoals: "Définir les objectifs",
    tasks: "Tâches",
    viewTasks: "Voir les tâches",
  },
  calendar: {
    title: "Calendrier",
    manageCalendar: "Gère ton calendrier et tes échéances",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    previousPeriod: "Période précédente",
    nextPeriod: "Période suivante",
    events: "Événements",
    allDayShort: "Journée",
    eventTitlePlaceholder: "Titre de l'événement",
    startDateLabel: "Date de début",
    associatedLead: "Lead associé",
    searchLead: "Rechercher un lead...",
    eventDescriptionPlaceholder: "Description de l'événement...",
    editEvent: "Modifier l'événement",
    newEvent: "Nouvel événement",
    eventTitle: "Titre",
    eventTitleRequired: "Le titre est requis.",
    eventType: "Type",
    endDateLabel: "Date de fin",
    eventColor: "Couleur",
    eventDescription: "Description",
    noEventsToExport: "Aucun événement à exporter",
    eventDeleted: "{{title}} supprimé",
    exportError: "Erreur lors de l'export du calendrier",
    meeting: "Réunion",
    followUp: "Suivi",
    followUpScheduled: "Suivi programmé pour",
    shooting: "Tournage",
    script: "Script",
    deadline: "Échéance",
    other: "Autre",
    blue: "Bleu",
    green: "Vert",
    yellow: "Jaune",
    orange: "Orange",
    red: "Rouge",
    purple: "Violet",
    cyan: "Cyan",
    rose: "Rose",
    endBeforeStart: "La date de fin ne peut pas être antérieure à la date de début.",
    showLeadFollowups: "Relances leads",
    showPersonalEvents: "Événements perso",
    showRightsEnds: "Fin des droits",
    rightsEndTitle: "Fin des droits · {{name}}",
    rightsEndDescription: "Fin des droits d'image pour {{name}}",
    addToGoogleCalendar: "Ajouter à Google Calendar",
    setupGoogleCalendar: "Connecter Google Calendar pour synchroniser",
    googleCalendarSynced: "Synchronisé vers « Leadsme »",
  },
  auth: {
    minPasswordLength: "Le mot de passe doit contenir au moins 8 caractères",
    passwordTooLong: "Le mot de passe ne peut pas dépasser 128 caractères",
    passwordNotWhitespace: "Le mot de passe ne peut pas être composé uniquement d'espaces",
    passwordNoUppercase: "Le mot de passe doit contenir au moins une majuscule",
    passwordNoLowercase: "Le mot de passe doit contenir au moins une minuscule",
    passwordNoDigit: "Le mot de passe doit contenir au moins un chiffre",
    passwordRequirements: "Minimum 8 caractères, une majuscule, une minuscule, un chiffre",
    forgotPassword: "Mot de passe oublié",
    forgotPasswordTitle: "Mot de passe oublié",
    emailAddress: "Adresse email",
    emailPlaceholder: "prenom@email.com",
    sending: "Envoi...",
    backToLogin: "Retour à la connexion",
    loginTitle: "Connexion",
    password: "Mot de passe",
    passwordPlaceholder: "Ton mot de passe",
    signIn: "Se connecter",
    signingIn: "Connexion...",
    signInError: "Erreur de connexion",
    oauthError: "Connexion Google interrompue. Réessaie.",
    noAccount: "Pas encore de compte ?",
    createAccount: "Créer un compte",
    continueWithGoogle: "Continuer avec Google",
    orContinueWithEmail: "Ou continuer avec l'email",
    signUpTitle: "Créer un compte",
    redirectingToApp: "Redirection en cours...",
    redirectingToPayment: "Redirection vers le paiement...",
    redirectingToResetPassword: "Préparation de la réinitialisation...",
    payment: {
      cancelledMessage: "Paiement non finalisé. Aucun montant n'a été débité. Tu peux réessayer ci-dessous.",
    },
    name: "Nom complet",
    namePlaceholder: "Ton nom complet",
    company: "Entreprise",
    companyPlaceholder: "Nom de ton entreprise (optionnel)",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Confirme ton mot de passe",
    signUp: "Créer le compte",
    signingUp: "Création...",
    signUpError: "Erreur lors de la création du compte",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    unexpectedError: "Une erreur inattendue est survenue",
    invalidEmail: "Entre une adresse email valide",
    emailAlreadyExistsMessage: "Un compte avec cette adresse email existe déjà.",
    alreadyHaveAccount: "Déjà un compte ?",
    signInLink: "Se connecter",
    termsTextPrefix: "En utilisant ce service, vous acceptez nos",
    termsLink: "CGVU",
    termsTextAnd: "et notre",
    privacyLink: "Politique de confidentialité",
    resetPasswordTitle: "Réinitialiser le mot de passe",
    newPassword: "Nouveau mot de passe",
    newPasswordPlaceholder: "Ton nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    confirmNewPasswordPlaceholder: "Confirme ton nouveau mot de passe",
    resetPassword: "Réinitialiser le mot de passe",
    resettingPassword: "Réinitialisation...",
    resetPasswordSuccess: "Mot de passe réinitialisé !",
    resetPasswordSuccessMessage: "Ton mot de passe a été réinitialisé avec succès. Redirection...",
    resetPasswordError: "Erreur lors de la réinitialisation",
    passwordSameAsOld: "Le nouveau mot de passe doit être différent de l'ancien",
    invalidResetLink: "Lien de réinitialisation invalide ou expiré",
    otpTitle: "Vérifie ton email",
    otpTitleLogin: "Finalise ton inscription",
    otpTitleForgot: "Réinitialise ton mot de passe",
    otpMessage: "Un code de vérification a été envoyé à",
    otpMessageForgot: "Pour réinitialiser ton mot de passe, un code de vérification a été envoyé à",
    sendResetCode: "Envoyer le code",
    otpMessageLogin: "Pour finaliser ton inscription, un code de vérification a été envoyé à",
    otpNotYourAccount: "Ce n'est pas ton compte ?",
    otpSpamWarning: "Pense à vérifier ton dossier spam.",
    otpCodeLabel: "Code de vérification (6 chiffres)",
    otpVerifying: "Vérification...",
    otpInvalid: "Code invalide ou expiré",
    otpInvalidLength: "Le code doit contenir 6 chiffres",
    otpVerifyError: "Erreur lors de la vérification du code",
    otpResend: "Renvoyer le code",
    otpResending: "Envoi...",
    otpResendError: "Erreur lors de l'envoi du code",
    otpResendAvailableIn: "Renvoi possible dans {{seconds}} s",
    otpResendRateLimited: "Réessaie dans {{seconds}} s",
    otpRateLimitedGeneric: "Patiente un instant avant de réessayer.",
    signUpRateLimited: "Réessaie dans {{seconds}} s",
    backToSignUp: "Retour à l'inscription",
  },
  status: {
    toContact: "À contacter",
    pending: "En attente",
    negotiation: "Négociation",
    inProduction: "En production",
    inProgress: "En cours",
    completed: "Terminé",
    abandoned: "Abandonné",
    paid: "Payé",
    rejected: "Refusé",
    unknown: "Inconnu",
  },
  settings: {
    title: "Paramètres",
    profile: "Profil",
    preferences: "Préférences",
    integrations: "Intégrations",
    integrationsSubtitle: "Centralise tes outils pour travailler sans quitter Leadsme.",
    integrationsConnectedCount: "{{connected}} connectées sur {{total}}",
    integrationConnected: "Connecté",
    integrationNotConnected: "Non connecté",
    integrationConnect: "Connecter",
    integrationDisconnect: "Déconnecter",
    appColor: "Couleur de l'app",
    eventTypeColors: "Types d'événements",
    googleCalendar: "Google Calendar",
    googleCalendarDescription:
      "Synchronise tes événements avec ton agenda.",
    googleCalendarConnect: "Connecter Google Calendar",
    googleCalendarDisconnect: "Déconnecter",
    googleCalendarConnected: "Connecté",
    googleCalendarSyncing: "Synchronisation des événements…",
    googleCalendarConnectedToast: "Google Calendar connecté",
    googleCalendarDisconnectedToast: "Google Calendar déconnecté",
    googleCalendarErrorToast: "Impossible de connecter Google Calendar",
    googleCalendarNotConfigured: "Cette intégration n’est pas encore disponible.",
    googleCalendarLoadError: "Impossible de vérifier la connexion. Réessaie.",
    googleCalendarConnecting: "Redirection…",
    googleGmail: "Gmail",
    googleGmailDescription:
      "Envoie tes emails directement depuis Leadsme.",
    googleGmailConnect: "Connecter Gmail",
    googleGmailDisconnect: "Déconnecter",
    googleGmailConnected: "Connecté",
    googleGmailConnectedToast: "Gmail connecté",
    googleGmailConnectedSignatureToast: "Gmail connecté. Tu peux ajouter ta signature.",
    googleGmailDisconnectedToast: "Gmail déconnecté",
    googleGmailErrorToast: "Impossible de connecter Gmail",
    googleGmailNotConfigured: "Cette intégration n’est pas encore disponible.",
    googleGmailLoadError: "Impossible de vérifier la connexion. Réessaie.",
    googleGmailConnecting: "Redirection…",
    googleDrive: "Google Drive",
    googleDriveDescription:
      "Ajoute et partage tes fichiers depuis tes projets.",
    googleDriveConnect: "Connecter Google Drive",
    googleDriveDisconnect: "Déconnecter",
    googleDriveConnected: "Connecté",
    googleDriveConnectedToast: "Google Drive connecté",
    googleDriveDisconnectedToast: "Google Drive déconnecté",
    googleDriveErrorToast: "Impossible de connecter Google Drive",
    googleDriveNotConfigured: "Cette intégration n’est pas encore disponible.",
    googleDriveConnecting: "Redirection…",
    superPdp: "Super PDP",
    superPdpDescription:
      "Facturation électronique via notre partenaire Super PDP, inclus dans Pro sans frais supplémentaires.",
    superPdpConnect: "Connecter Super PDP",
    superPdpProFeatureTitle: "Fonctionnalité Pro",
    superPdpProFeatureMessage:
      "Passe à Pro pour connecter Super PDP et gérer l’envoi de tes factures électroniques.",
    superPdpComingSoonToast: "La connexion Super PDP arrive bientôt.",
    emailSignature: "Signature email",
    emailSignatureDescription: "Ajoutée automatiquement à l’envoi Gmail.",
    emailSignaturePlaceholder: "Colle ou saisis ta signature…",
    emailSignatureSaveError: "Impossible d’enregistrer la signature",
    emailSignatureTooLargeHtml: "Signature trop volumineuse (max {{max}}).",
    emailSignatureTooLargePlain: "Signature trop longue (max {{max}}).",
    followUpReminder: "Rappel des suivis",
    followUpReminderDescription: "Sois averti quand des suivis sont prévus sur tes leads.",
    followUpReminderSaveError: "Impossible d’enregistrer la préférence de rappel",
    accentBlue: "Bleu",
    accentIndigo: "Indigo",
    accentCyan: "Cyan",
    accentTeal: "Sarcelle",
    accentEmerald: "Émeraude",
    accentViolet: "Violet",
    accentRose: "Rose",
    accentOrange: "Orange",
    accentAmber: "Ambre",
    accentSlate: "Ardoise",
    account: "Compte",
    financial: "Financier",
    identity: "Identité",
    language: "Langue",
    profileInfo: "Informations du profil",
    name: "Nom",
    nameRequired: "Le nom est requis",
    company: "Entreprise",
    taxRateRequired: "Le taux d'imposition est requis",
    positiveRate: "Le taux doit être positif",
    maxRate: "Le taux ne peut pas dépasser 100%",
    information: "Information",
    taxRateHint: "Ce taux sert à estimer tes impôts dans Finances. Les barèmes officiels évoluent. Consulte :",
    microEnterprise: "Fiscalité de la micro-entreprise",
    eurlSasu: "Impôt sur les sociétés (EURL / SASU)",
    consultAccountant: "En cas de doute, demande conseil à ton comptable.",
    siretLabel: "SIRET",
    siretPlaceholder: "123 456 789 00012",
    siretInvalid: "SIRET invalide (14 chiffres).",
    sirenDerived: "SIREN",
    billingIdentity: "Facturation",
    vatNumberLabel: "N° TVA (si applicable)",
    vatNumberPlaceholder: "FR12345678901",
    vatNumberInvalid: "N° TVA invalide.",
    addressLine1Label: "Adresse",
    addressLine1Placeholder: "12 rue de la Paix",
    addressLine2Label: "Complément d’adresse",
    addressLine2Placeholder: "Bâtiment, étage…",
    postalCodeLabel: "Code postal",
    postalCodePlaceholder: "75002",
    cityLabel: "Ville",
    cityPlaceholder: "Paris",
    countryCodeLabel: "Pays",
    countryCodeInvalid: "Code pays à 2 lettres (ex. FR).",
    subtitle: "Gère les paramètres de ton compte et tes préférences",
    profileUpdateError: "Erreur lors de la mise à jour du profil",
    profileUpdateSuccess: "Profil mis à jour avec succès !",
    updateSuccess: "Profil mis à jour avec succès !",
    updateError: "Erreur lors de la mise à jour du profil",
    companyPlaceholder: "Nom de l'entreprise",
    taxRateLabel: "Taux d'imposition (%)",
    subscription: "Abonnement",
    currentPlan: "Plan actuel",
    planFree: "Gratuit",
    planPro: "Pro",
    planFreeDescription: "Pour commencer simplement",
    planProDescription: "Pour développer ton activité",
    manageSubscription: "Gérer l'abonnement",
    portalError: "Erreur lors de l'ouverture du portail de gestion. Réessaie.",
    dataExport: "Export de données",
    dataExportDescription: "Télécharge toutes tes données au format JSON",
    downloadAllData: "Télécharger toutes mes données",
    exportingData: "Export en cours...",
    exportCooldown: "Patiente {{minutes}} min {{seconds}} s avant un nouvel export",
    exportCooldownRemaining: "Réessayer dans {{minutes}} min {{seconds}} s",
    dataExportSuccess: "Export réussi ! Téléchargement en cours...",
    dataExportError: "Erreur lors de l'export de tes données",
    deleteAccount: "Supprimer mon compte",
    deleteAccountDescription:
      "Supprime définitivement ton compte, tes données et résilie un éventuel abonnement. Cette action est irréversible.",
    deleteAccountButton: "Supprimer mon compte",
    deleteAccountTitle: "Supprimer ton compte",
    deleteAccountWarningTitle: "Cette action est définitive",
    deleteAccountWarningBody:
      "Tes leads, projets, fichiers, modèles et préférences seront définitivement supprimés. Si tu as un abonnement Pro, il sera résilié immédiatement.",
    deleteAccountReasonLabel: "Pourquoi pars-tu ?",
    deleteAccountCommentLabel: "Un commentaire",
    deleteAccountOptional: "optionnel",
    deleteAccountReasonPlaceholder: "Choisir une raison",
    deleteAccountCommentPlaceholder: "Dis-nous ce qui aurait pu être mieux…",
    deleteAccountConfirmPrompt: "Pour confirmer, tape {{word}} :",
    deleteAccountConfirm: "Supprimer définitivement",
    deleteAccountDeleting: "Suppression en cours…",
    deleteAccountError: "Impossible de supprimer le compte. Réessaie ou contacte le support.",
    deleteAccountSuccess: "Ton compte a été supprimé.",
    deleteAccountReasons: {
      too_expensive: "Trop cher",
      missing_features: "Fonctionnalités manquantes",
      too_complex: "Trop complexe",
      switched_tool: "Je suis passé à un autre outil",
      not_using: "Je n'utilise plus Leadsme",
      other: "Autre",
    },
    usageLeads: "Leads actifs",
    usageProjects: "Projets actifs",
    usageEmailTemplates: "Modèles de messages",
    usagePayments: "Suivis de paiement actifs",
    usageEvents: "Événements du calendrier",
    usageStorage: "Stockage",
    unlimited: "Illimité",
    enabled: "Activé",
    disabled: "Désactivé",
    featureIncluded: "Inclus",
    featureNotIncluded: "Non inclus",
    usageError: "Impossible de charger l'utilisation",
    quotaLimitReached: "Limite atteinte",
    quotaLimitSimpleMessage:
      "Limite {{resource}} atteinte. Supprime des éléments pour libérer de la place, ou passe en Pro.",
    quotaLimitProjectsMessage:
      "Limite de projets actifs atteinte. Archive un projet pour libérer une place, ou passe en Pro.",
    quotaLimitPaymentsMessage:
      "Limite de suivis de paiement actifs atteinte. Passe des paiements en « payé » pour libérer une place, ou passe en Pro.",
    quotaLimitLeadsMessage:
      "Limite de leads actifs atteinte. Abandonne un lead froid pour libérer une place, ou passe en Pro.",
    quotaArchiveNamed: "Archiver « {{name}} »",
    quotaArchiveSuccess: "« {{name}} » archivé",
    quotaArchiveFailed: "Impossible d'archiver le projet",
    quotaMarkPaidNamed: "Passer « {{name}} » en payé",
    quotaMarkPaidSuccess: "« {{name}} » marqué comme payé",
    quotaMarkPaidFailed: "Impossible de marquer le paiement comme payé",
    quotaAbandonNamed: "Abandonner « {{name}} »",
    quotaAbandonSuccess: "« {{name}} » abandonné",
    quotaAbandonFailed: "Impossible d'abandonner le lead",
    app: "Application",
  },
  import: {
    title: "Importer des données",
    success: "{{count}} élément(s) importé(s) avec succès",
    steps: {
      upload: "Fichier",
      mapping: "Colonnes",
      preview: "Import",
    },
    columnDescriptions: {
    },
    upload: {
      csvTab: "Fichier CSV/TSV",
      pasteTab: "Coller des données",
      dragDrop: "Glisser-déposer, ou parcourir tes fichiers",
      pasteInstructionsList: {
      },
      pastePlaceholder: "Colle tes données ici...\n\nLa première ligne doit contenir les en-têtes.\nSéparateur : tabulation ou virgule.",
      fileReady: "Fichier prêt",
      or: "ou",
      browse: "parcours tes fichiers",
      maxSize: "Taille max: 10MB",
    },
    mapping: {
      ignoreColumn: "-- Ignorer cette colonne --",
      rows: "Lignes",
      columns: "Colonnes",
      dateFormatTitle: "Format des dates dans le fichier importé",
      matchColumns: "Associe les colonnes de ton fichier",
    },
    preview: {
      warnings: "Avertissements :",
      errorsFound: "Erreurs détectées",
      tableTitle: "Aperçu des données",
      rows: "lignes",
      moreRows: "autres lignes",
      rowsImported: "lignes importées avec succès",
      importError: "Erreur lors de l'importation des données",
    },
    buttons: {
      previous: "Précédent",
      import: "Importer",
      continue: "Continuer",
      preview: "Prévisualiser",
      importing: "Import en cours...",
    },
    validation: {
      invalidFile: "Sélectionne un fichier CSV ou TSV valide.",
    },
  },
  landing: {
    home: "Accueil",
    seoTitle: "Leadsme - CRM pour créateurs UGC",
    description: "Arrête de perdre des leads UGC. Gère chaque marque, projet, paiement et relance au même endroit. Conçu pour les créateurs UGC. Plan gratuit. Sans carte bancaire pour s'inscrire.",
    pricing: "Tarifs",
    contact: "Contact",
    signIn: "Se connecter",
    heroTitle: "Arrête de te perdre dans tes",
    heroTitleHighlight: "collabs UGC.",
    heroDescription: "Gère toute ton activité au même endroit.",
    heroBadge: "Pensé par des créateurs, pour les créateurs",
    ctaButton: "Commencer gratuitement",
    headerSignup: "S'inscrire",
    trustSignup: "Gratuit, sans carte bancaire",
    trustCancelAnytime: "Annulable à tout moment",
    heroScrollCue: "En savoir plus",
    heroDemoVideoLabel: "Démonstration de l'interface Leadsme",
    featuresEyebrow: "Voir comment ça marche",
    painEyebrow: "Les problèmes les plus fréquents",
    painPoint1: "Tu oublies de relancer certaines marques",
    painPoint2: "Tu ne sais plus où en est chaque collaboration",
    painPoint3: "Tes briefs et tes informations sont dispersés",
    painPoint4: "Tu perds de vue les paiements en attente",
    painSolutionPrefix: "Avec Leadsme, tu gardes",
    painSolutionHighlight: "une vue claire sur toute ton activité.",
    whyTitle: "Tu te reconnais là-dedans ?",
    whySubtitle: "Entre la prospection, les projets et les paiements, tu commences à t’éparpiller.",
    featuresTitle: "Voici comment Leadsme t'aide à ne plus rien oublier",
    featureDashboardLabel: "Tableau de bord",
    featureDashboardTitle: "Vois toute ton activité en un coup d'œil",
    featureDashboardDescription: "Suis tes performances en temps réel avec des métriques clés et des graphiques détaillés. Identifie tes meilleurs leads et projets.",
    dashboardBenefit1: "Vue en temps réel de tes métriques et performances",
    dashboardBenefit2: "Identifie tes meilleurs leads et projets les plus rentables",
    dashboardBenefit3: "Suis tes revenus et relances en un coup d'œil",
    featureLeadsLabel: "Leads",
    featureLeadsTitle: "Ne perds plus la trace de tes marques",
    featureLeadsDescription: "Suis tes prospects, organise tes contacts et gère ton pipeline. Ne rate plus jamais une opportunité.",
    leadsBenefit1: "Centralise chaque marque et contact",
    leadsBenefit2: "N'oublie plus jamais une relance",
    leadsBenefit3: "Transforme tes prospects en collaborations payées",
    featureProjectsLabel: "Projets",
    featureProjectsTitle: "Maîtrise chaque livrable",
    featureProjectsDescription: "Organise tes projets en Kanban, suis les livrables et gère les corrections. Reste maître de tes productions.",
    projectsBenefit1: "Vue Kanban pour suivre l'avancement des projets",
    projectsBenefit2: "Ne rate plus aucune deadline de livrable",
    projectsBenefit3: "Lie ou envoie tes docs vers Google Drive",
    featureCalendarLabel: "Calendrier",
    featureCalendarTitle: "Ne rate plus aucune deadline",
    featureCalendarDescription: "Gère ton calendrier, planifie tes relances et visualise tes échéances. Organise ton temps efficacement.",
    calendarBenefit1: "Ne rate plus aucune deadline",
    calendarBenefit2: "Visualise ton planning en un coup d'œil",
    calendarBenefit3: "Synchronise tes événements avec Google Calendar",
    featureFinancesLabel: "Finances",
    featureFinancesTitle: "Ne perds plus la trace de tes paiements",
    featureFinancesDescription: "Suis les paiements attendus et reçus au même endroit. Garde le contrôle de ta trésorerie sans rien laisser passer.",
    financesBenefit1: "Vois d'un coup d'œil ce qu'il te reste à encaisser",
    financesBenefit2: "Suis chaque paiement au même endroit",
    financesBenefit3: "Arrête de courir après les collaborations impayées",
    featureMessagesLabel: "Messages",
    featureMessagesTitle: "Réponds aux marques et agences en quelques secondes",
    featureMessagesDescription: "Crée et gère tes modèles de messages personnalisés pour tes leads. Automatise ta communication et gagne du temps.",
    messagesBenefit1: "Envoie tes modèles via Gmail en un clic",
    messagesBenefit2: "Automatise tes prises de contact et relances",
    messagesBenefit3: "Gagne des heures sur les messages répétitifs",
    heroCompatLabel: "Compatible avec",
    integrationsEyebrow: "Intégrations Google",
    integrationsTitle: "Tes outils du quotidien, directement dans Leadsme",
    integrationsDescription:
      "Gagne du temps en connectant Gmail, Google Calendar et Google Drive.",
    integrationsGmailName: "Gmail",
    integrationsGmailDescription:
      "Envoie tes emails aux marques directement depuis Leadsme.",
    integrationsCalendarName: "Google Calendar",
    integrationsCalendarDescription:
      "Retrouve tes appels, tournages et échéances dans ton agenda.",
    integrationsDriveName: "Google Drive",
    integrationsDriveDescription:
      "Ajoute tes briefs et livrables sans multiplier les fichiers éparpillés.",
    benefitsTitle: "Pourquoi choisir Leadsme ?",
    benefitSpeedTitle: "Rapide et efficace",
    benefitSpeedDescription: "Gagne du temps sur la gestion administrative et concentre-toi sur la création de contenu.",
    benefitSimpleTitle: "Simple et intuitif",
    benefitSimpleDescription: "Interface intuitive conçue pour les créateurs de contenus. Prends en main la plateforme en quelques minutes.",
    benefitGrowthTitle: "Fais grandir ton activité",
    benefitGrowthDescription: "Suis tes performances et optimise ton pipeline pour générer plus de revenus.",
    faqTitle: "Questions fréquentes",
    faq1Question: "Puis-je annuler à tout moment ?",
    faq1Answer: "Oui. Annule à tout moment depuis les paramètres de ton compte.",
    faq2Question: "Mes données sont-elles en sécurité ?",
    faq2Answer: "Oui. Tes données sont privées, accessibles uniquement depuis ton compte, et ne sont pas partagées.",
    faq3Question: "Puis-je passer au plan Pro plus tard ?",
    faq3Answer: "Oui. Commence gratuitement et passe au Pro quand tu veux.",
    faq4Question: "Ai-je besoin d'une carte bancaire ?",
    faq4Answer: "Non. Le plan gratuit ne demande aucune carte.",
    ctaTitle: "Alors, qu'attends-tu pour sauter le pas ?",
    ctaDescription: "Commence gratuitement et gère tes marques, projets et paiements au même endroit.",
    copyright: "© 2025 Leadsme. Tous droits réservés.",
    footerLegalNav: "Informations légales",
    legalMentions: "Mentions légales",
    privacyPolicy: "Confidentialité",
    termsOfService: "CGVU",
  },
  pricing: {
    title: "Tarifs",
    description: "Commence gratuitement,\npasse au Pro quand tu veux.",
    planFree: "Gratuit",
    planFreeDescription: "Pour commencer simplement",
    planPro: "Pro",
    planProDescription: "Pour développer ton activité",
    planProDescriptionYearly: "Tous les avantages Pro, à prix réduit",
    planPopular: "Populaire",
    pricePerMonth: "/mois",
    pricePerMonthTTC: "/mois TTC",
    pricePerYearTTC: "/an TTC",
    tryFreeFor14Days: "Essayer gratuitement 14 jours",
    then: "puis",
    bestPrice: "2 mois offerts",
    annual: "Annuel",
    monthly: "Mensuel",
    ctaFree: "Créer mon espace gratuitement",
    ctaNoCard: "Sans carte bancaire",
    showFeatures: "Voir ce qui est inclus",
    proSectionTitle: "Plus tard, si tu en as besoin",
    featureUnlimitedLeads: "Leads illimités",
    featureUnlimitedProjects: "Projets illimités",
    featureUnlimitedTemplates: "Modèles de messages illimités",
    featureUnlimitedPayments: "Suivis de paiement illimités",
    featureUnlimitedEvents: "Événements illimités",
    featureActiveLeads: "{{count}} leads actifs",
    featureActiveProjects: "{{count}} projets actifs",
    featureActivePayments: "{{count}} suivis de paiement actifs",
    featureLimitedTemplates: "{{count}} modèles de messages",
    featureLimitedEvents: "{{count}} événements",
    featureEvents: "événements",
    featureStorage: "{{size}} de stockage",
    featureAIRewrite: "Réécriture avec l’IA",
    checkoutError: "Une erreur est survenue lors du paiement. Réessaie plus tard.",
  },
  contact: {
    title: "Écrire à l'équipe",
    description:
      "On construit Leadsme pour vous. Une question, un bug, une idée ? Dis-nous ce qui bloque ou ce qui manque, on lit tout.",
    name: "Nom",
    namePlaceholder: "Ton nom",
    email: "Email",
    emailPlaceholder: "ton@email.com",
    message: "Message",
    messagePlaceholder: "Ton message…",
    submitButton: "Envoyer le message",
    successTitle: "Message envoyé !",
    successMessage: "On te répond dès que possible.",
    rateLimited: "Trop de messages envoyés. Réessaie dans quelques minutes.",
    sendError: "Une erreur est survenue. Réessaie plus tard.",
    companyHoneypot: "Société",
  },
  pwa: {
    install: "Installer l'app",
    installed: "App installée",
    installTitle: "Installation de l'application",
    installDescription: "Installe Leadsme sur ton appareil pour un accès rapide depuis l'écran d'accueil.",
    manualInstallTitle: "Installation manuelle",
    manualInstallChrome: "Clique sur l'icône d'installation dans la barre d'adresse, ou Menu > Installer l'application",
    manualInstallSafari: "Appuie sur Partager > Ajouter à l'écran d'accueil",
    manualInstallFirefox: "Menu > Installer",
  },
  notFound: {
    title: "Page introuvable",
    description: "Désolé, on n'a pas trouvé la page que tu recherches.",
    goBack: "Retour",
    goToHome: "Aller à l'accueil",
    goToDashboard: "Aller au tableau de bord",
  },
  blog: {
    nav: "Blog",
    seoTitle: "Blog Leadsme : conseils pour créateurs UGC",
    seoDescription: "Guides pratiques pour réussir ta prospection UGC, gérer tes collabs et développer ton activité de créateur de contenu.",
    title: "Le blog Leadsme",
    subtitle: "Guides pratiques pour les créateurs UGC : prospection, collaborations, modèles d'emails et outils.",
    mediaEyebrow: "Le média des créateurs UGC",
    heroTitle: "De la prospection à la collab, sans improviser.",
    heroSubtitle: "Des guides concrets pour trouver les bonnes marques, défendre tes tarifs et piloter ton activité.",
    allGuides: "Tous les guides",
    filterAll: "Tous",
    readArticle: "Lire l'article",
    empty: "Aucun article pour l'instant.",
    emptyFilter: "Aucun guide pour ce thème.",
    readingTime: "{{minutes}} min de lecture",
    backToBlog: "Retour au blog",
    relatedTitle: "À lire aussi",
    postSeoSuffix: "Leadsme Blog",
    mockToContact: "À contacter",
    mockToFollowUp: "À relancer",
    mockConfirmed: "Confirmée",
    mockAddBrand: "Ajouter une marque",
    postCtaTitle: "Ne perds plus le fil de tes échanges avec les marques",
    postCtaDescription: "Suis tes contacts et planifie tes prochaines relances avec Leadsme.",
    postCtaButton: "Créer mon espace gratuitement",
    postCtaOrganizeTitle: "Prêt·e à mieux organiser ta prospection ?",
    postCtaOrganizeDescription: "Centralise tes marques, tes contacts et tes prochaines relances au même endroit avec Leadsme.",
    postCtaOrganizeTrust: "Gratuit pour commencer",
    postCtaTrackTitle: "Prêt·e à mieux suivre tes collaborations ?",
    postCtaTrackDescription: "Centralise tes marques, tes projets, les montants négociés et tes paiements au même endroit avec Leadsme.",
    postCtaTrackTrust: "Gratuit pour commencer",
  },
  legal: legalTranslations,
  privacy: privacyTranslations,
  terms: termsTranslations,
} as const;
